import { render, staticRenderFns } from "./AdditionalFieldsMultiLanguageTextArea.vue?vue&type=template&id=60b82cf6&scoped=true&lang=pug&"
import script from "./AdditionalFieldsMultiLanguageTextArea.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFieldsMultiLanguageTextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b82cf6",
  null
  
)

export default component.exports